import "./publishers_view_object.scss"

